export const shortId = () => Math.random().toString(6).slice(-6);
